export default __webpack_public_path__ + "static/media/containerLifted.0358b1e5.png";